module.exports = __webpack_public_path__ + "img/km.66c55850.svg";